export type ISMSController = ReturnType<typeof SMSControllerFactory>;

export const SMSControllerFactory = ({
  smsService,
}: {
  smsService: ISMSService;
}) => {
  const sendOTP = async (payload: { phone_number: string }) => {
    return await smsService.sendOTP(payload);
  };

  const verifyOTP = async (payload: {
    uniqueRequestId: string;
    otp: string;
  }) => {
    return await smsService.verifyOTP(payload);
  };

  const savePhoneNumber = async (payload: { phone_number: string }) => {
    return await smsService.savePhoneNumber(payload);
  };

  const getPhoneNumber = async () => {
    return await smsService.getPhoneNumber();
  };

  const bindTexting = async (payload: {
    phone_number: string;
    clinic_id?: number;
  }) => {
    return await smsService.bindTexting(payload);
  };

  const getTextingStatus = async () => {
    return await smsService.getTextingStatus();
  };

  const revokeTexting = async (payload: { phone_number: string }) => {
    return await smsService.revokeTexting(payload);
  };

  return {
    sendOTP,
    verifyOTP,
    savePhoneNumber,
    getPhoneNumber,
    bindTexting,
    getTextingStatus,
    revokeTexting,
  };
};
